module.exports = __webpack_public_path__ + "static/media/capital-markets-icon.602e5ee5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/usecase-jet/assets/capital-markets-icon.svg
// module id = 69
// module chunks = 0